import React, { FunctionComponent } from 'react';
import { Colors, Theme } from '@inplayer-org/inplayer-ui';
import { ifProp } from 'styled-tools';
import styled, { StyledComponent } from 'styled-components';

// images
import inplayerLogo from 'assets/pics/icons/inplayer-icon-large.svg';

const HeaderWrapper = styled.div`
  position: relative;
`;

const CloseIcon = styled.span`
  position: absolute;
  right: 2%;
  top: 8px;
  color: ${Colors.asbestos};
  font-size: 25px;
  z-index: 1;
`;

interface BrandHeaderContainerProps {
  backgroundColor: string;
}

const BrandHeaderContainer: StyledComponent<'div', Theme, BrandHeaderContainerProps> = styled.div`
  width: 100%;
  box-sizing: border-box;
  background: ${({ backgroundColor }: BrandHeaderContainerProps) =>
    ifProp('backgroundColor', backgroundColor, Colors.skyBlue)};
  padding: 2vh 0;
  position: relative;
  border-bottom: 1px solid ${Colors.lightGray};
  text-align: center;
  display: flex;
  justify-content: center;
`;

const LogoImage = styled.img`
  max-width: 32%;
  max-height: 12vh;
`;

interface Props {
  backgroundColor?: string;
  brandLogo?: string;
  hideLogo?: boolean;
}

const BrandHeader: FunctionComponent<Props> = ({ backgroundColor, brandLogo, hideLogo }) => {
  return (
    <HeaderWrapper>
      <CloseIcon>x</CloseIcon>
      <BrandHeaderContainer backgroundColor={backgroundColor!}>
        {hideLogo && <LogoImage alt="logo" src={brandLogo || inplayerLogo} />}
      </BrandHeaderContainer>
    </HeaderWrapper>
  );
};

export default BrandHeader;
